// extracted by mini-css-extract-plugin
module.exports = {"link":"animated_link-module__link--2DC4o","icon":"animated_link-module__icon--2ePvE","label":"animated_link-module__label--3tPCp"};